<template>
	<div>
			<div class="home_topic">
					<div class="topic-item" v-for='(item, index) in moduleList' :key="i" @click="activityTo(item)">
							<img class="topic-item-icon" :src="item.photo" />
					</div>
			</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ENUM } from '../../../const/enum.js';

export default {
  name: "Hometopic",
  computed: {
  	...mapState({
			isOnline: state => state.auth.isOnline,
			moduleList: state => state.home.moduleList,
			orderStatus: state => state.order.orderStatus,
		}),
	},
	created() {
		if (this.moduleList && this.moduleList.length) {
      console.dir(this.moduleList)
    }else{
      this.fetchModulelLst({}).then(
        response => {
           console.dir(this.moduleList)
				},
        error => {}
      )
    }
   
	},
  methods: {
		...mapActions({
      fetchModulelLst: 'fetchModulelLst',
		}),
  	activityTo: function(item) {
      let url =  item.url || ""
      if (url && url.indexOf("http")>-1) {
        window.location.href = url
      }else{
        this.$router.push({ name: item.url});
      }  
  	}
  }
};
</script>
<style lang="scss" scoped>
.home_topic {
  width: 98vw;
  max-width: 98vw;
  margin: 0 auto;
  display: flex;
	flex-wrap: wrap;
  justify-content: space-around;
  background: #FFFFFF;
  .topic-item {
    margin-bottom: 1vw;
    .topic-item-icon {
      width: 46vw;
      height: 25vw;
      overflow: hidden;
    }
    .topic-item-title {
      color: #333333;
      font-size: 12px;
      margin-top: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/child/HomeTopic.vue